export default __webpack_public_path__ + "static/media/005-cake.316a9bd6.svg";